export const siteColumnData = {
  info: [
    // { key: 'siteAssessmentID', label: 'ID', width: null, hidden: true, primaryKey: true },
    { key: 'descriptionType', label: 'Description Type', width: null, primaryKey: true },
    { key: 'standingType', label: 'Standing Type', width: null },
    { key: 'urea', label: 'urea', width: null },
    { key: 'timberQuality', label: 'Timber Quality', width: null },
    { key: 'access', label: 'Access', width: null },
  ],
  siteVolume: [
    { key: 'subCompartmentName', label: 'Sub Compartment', width: 200, primaryKey: true },
    { key: 'avgTreeSize', label: 'Avg Tree', width: null },
    { key: 'treesPerHectare', label: 'Trees Per Ha', width: null },
    { key: 'percentCovered', label: '%age of Forest Covered', width: null },
    { key: 'updatedAreaInHa', label: 'Site Volume Area in Ha', width: null },
    { key: 'totalVolume', label: 'Total Volume', width: null },
    { key: 'totalTons', label: 'Total Tons', width: null },
    { key: 'totalTonsPerHa', label: 'Total Tons Per Ha', width: null },
    { key: 'totalVolPerHa', label: 'Total Volume Per Ha', width: null },
  ],
  products: [
    // { key: 'siteAssessmentID', label: 'ID', width: null, hidden: true },
    { key: 'products', label: 'Products', width: null, primaryKey: true },
    { key: 'subCompartmentName', label: 'Sub Compartment', width: null },
    // { key: 'productsMinDia', label: 'Products Min Dia', width: null },
    { key: 'productsPercent', label: 'Products %', width: null },
    { key: 'productsDestination', label: 'Products Destination', width: null },
    { key: 'customerName', label: 'Customer Name', width: null },
    { key: 'productsPricePerTonne', label: 'Products Price/Tonne', width: null },
  ],
  species: [
    // { key: 'siteAssessmentID', label: 'ID', width: null, hidden: true, primaryKey: true },
    { key: 'species', label: 'Species', width: null, primaryKey: true },
    { key: 'subCompartmentName', label: 'Sub Compartment', width: null },
    { key: 'sampleName', label: 'Sample Name', width: null },
    { key: 'areaInHa', label: 'Area In Ha', width: null },
    { key: 'percentageOfSite', label: 'Percentage Of Site', width: null },
  ],
  checklist: [
    // { key: 'siteAssessmentID', label: 'ID', width: null, hidden: true, primaryKey: true },
    { key: 'bankAccountDetails', label: 'Bank Acc Details', width: null, primaryKey: true },
    { key: 'dropPinUpdatedonWhatsApp', label: 'DropPin Updated on WhatsApp', width: null },
    { key: 'dropPinUpdatedonGoogleMaps', label: 'DropPin Updated on GoogleMaps', width: null },
    { key: 'safetyStatement', label: 'Safety Statement', width: null },
    { key: 'copyoffellinglicensesattached', label: 'Copy of Felling licenses Attached', width: null },
    {
      key: 'serviceItemsforMachineandMachineServicesUptodate',
      label: 'Service Items for Machine and Machine Services Uptodate',
      width: null,
    },
    { key: 'confirmCertifiedFireExtinguisheronsite', label: 'Confirm Certified Fire Extinguisher on Site', width: null },
    { key: 'safetySignserected', label: 'Safety Sign Serected', width: null },
    { key: 'siteMonitoringForms', label: 'Site Monitoring Forms', width: null },
    { key: 'googleHarvestPlancompleted', label: 'Google Harvest Plan Completed', width: null },
    { key: 'jotformHarvestPlansenttoOperator', label: 'Jotform Harvest Plan Sent to Operator', width: null },
    { key: 'isPlantHealthCheckDone', label: 'Plant Health Check Done', width: null },
  ],
  geolocations: [
    // { key: 'siteAssessmentID', label: 'ID', width: null, hidden: true, primaryKey: true, },
    { key: 'travelRouteDropPinLink', label: 'Travel Route DropPin Link', width: null, link: true },
    { key: 'entranceDropPinLink', label: 'Entrance DropPin Link', width: null, link: true },
    { key: 'timberDropPinLink', label: 'Timber DropPin Link', width: null, link: true },
    { key: 'timber2DropPinLink', label: 'Timber2 DropPin Link', width: null, link: true },
    { key: 'timber3DropPinLink', label: 'Timber3 DropPin Link', width: null, link: true },
    { key: 'stackingArea1DropPinLink', label: 'Stacking Area1 DropPin Link', width: null, link: true },
    { key: 'stackingArea2DropPinLink', label: 'Stacking Area2 DropPin Link', width: null, link: true },
    { key: 'turntable1DropPinLink', label: 'Turntable1 DropPin Link', width: null, link: true },
    { key: 'turntable2DropPinLink', label: 'Turntable2 DropPin Link', width: null, link: true },
    { key: 'machineDropoffAreaLink', label: 'Machine Dropoff Area Link', width: null, link: true },
    { key: 'dropPinVia', label: 'DropPin Via', width: null, link: true },
    { key: 'dropPinForestGate', label: 'DropPin Forest Gate', width: null, link: true },
    { key: 'dropPinTimberLocation', label: 'DropPin Timber Location', width: null, link: true },
  ],
  harvesting: [
    // { key: 'siteAssessmentID', label: 'ID', width: null, hidden: true, primaryKey: true },
    { key: 'treeHeight', label: 'Tree Height', width: null, primaryKey: true },
    { key: 'volumePerWeekHarvestor', label: 'Volume/Week Harvestor', width: null },
    { key: 'volumePerWeekForwarder', label: 'Volume/Week Forwarder', width: null },
    { key: 'roadorStackingArea', label: 'Roado rStacking Area', width: null },
    { key: 'extractionOver300meters', label: 'Extraction Over 300m', width: null },
    { key: 'restrictedAccess', label: 'Restricted Access', width: null },
    { key: 'tracksWheelchains', label: 'Tracks Wheelchains', width: null },
    { key: 'tracksWheelchainsPercent', label: 'Tracks Wheelchains %', width: null },
    { key: 'tracksWheelchainsDays', label: 'Tracks Wheelchains Days', width: null },
    { key: 'lowloader', label: 'Lowloader', width: null },
    { key: 'lowloaderPercent', label: 'Lowloader %', width: null },
    { key: 'lowloaderDays', label: 'Lowloader Days', width: null },
    { key: 'diggerWork', label: 'Digger Work', width: null },
    { key: 'diggerWorkPercent', label: 'Digger Work %', width: null },
    { key: 'diggerWorkDays', label: 'Digger Work Days', width: null },
    { key: 'chainsawWork', label: 'Chainsaw Work', width: null },
    { key: 'chainsawWorkPercent', label: 'Chainsaw Work %', width: null },
    { key: 'chainsawWorkDays', label: 'Chainsaw Work Days', width: null },
    { key: 'thinning1_TreesPerHct', label: 'Thinning1_TreesPerHct', width: null },
    { key: 'thinning1_Note', label: 'Thinning1_Note', width: null },
    { key: 'thinning2_TreesPerHct', label: 'Thinning2_TreesPerHct', width: null },
    { key: 'thinning2_Note', label: 'Thinning2_Note', width: null },
    { key: 'thinning3_TreesPerHct', label: 'Thinning3_TreesPerHct', width: null },
    { key: 'thinning3_Note', label: 'Thinning3_Note', width: null },
  ],
  hazards: [
    // { key: 'siteAssessmentID', label: 'ID', width: null, hidden: true, primaryKey: true },
    { key: 'powerlines', label: 'Powerlines', width: null, primaryKey: true },
    { key: 'groundSlope', label: 'Ground Slope', width: null },
    { key: 'groundCondition', label: 'Ground Condition', width: null },
    { key: 'streamsDrains', label: 'Streams Drains', width: null },
    { key: 'undergroundCables', label: 'Underground Cables', width: null },
    { key: 'other', label: 'Other', width: null },
    { key: 'roadSlope', label: 'Road Slope', width: null },
    { key: 'roadCondition', label: 'Road Condition', width: null },
    { key: 'powerlines_2', label: 'Powerlines_2', width: null },
    { key: 'streamsDrains_2', label: 'Streams Drains_2', width: null },
    { key: 'other_2', label: 'Other_2', width: null },
  ],
};
